import {get,post, request} from './request';


/***
 * 获取会员收货地址
 */
const getDeliveryAddressList = function (){
    return get(`/api/address/selReceiverAddressList?pageSize=100`)
        .then(res=>res.data).catch(err=>console.log(err))
}

export {getDeliveryAddressList}
